/*
* 募集金額計算
*/

export default class TargetAmount {
  constructor() {
    this.$displayAmount = document.getElementById('displayAmount');
    this.$displayMinUnit = document.getElementById('displayMinUnit');
    this.$displayMinAmount = document.getElementById('displayMinAmount');
    this.$displayMaxUnit = document.getElementById('displayMaxUnit');
    this.$displayMaxAmount = document.getElementById('displayMaxAmount');
    this.$displayTotalAmount = document.getElementById('displayTotalAmount');
    this.$displayRatio = document.getElementById('displayRatio');
    this.$displaySubordinatedAmount = document.getElementById('displaySubordinatedAmount');
  }

  attachEvent() {
    const numberOfUnits = document.getElementById('numberOfUnits');
    const unitPrice = document.getElementById('unitPrice');
    const minInvestmentUnit = document.getElementById('minInvestmentUnit');
    const maxInvestmentUnit = document.getElementById('maxInvestmentUnit');
    const subordinatedAmount = document.getElementById('subordinatedAmount');

    const displayAmount = this.$displayAmount;
    const displayMinUnit = this.$displayMinUnit;
    const displayMinAmount = this.$displayMinAmount;
    const displayMaxUnit = this.$displayMaxUnit;
    const displayMaxAmount = this.$displayMaxAmount;
    const displayTotalAmount = this.$displayTotalAmount;
    const displayRatio = this.$displayRatio;
    const displaySubordinatedAmount = this.$displaySubordinatedAmount;

    if (displayAmount != null) {
      window.addEventListener('pageshow', () => {
        calculateAmount();
        minUnit();
        maxUnit();
        calculateMinAmount();
        calculateMaxAmount();
        subordinated();
        calculateTotalAmount();
        calculateRatio();
      });
      numberOfUnits.addEventListener('change', () => {
        calculateAmount();
        calculateTotalAmount();
        calculateRatio();
      });
      unitPrice.addEventListener('change', () => {
        calculateAmount();
        calculateMinAmount();
        calculateMaxAmount();
        calculateTotalAmount();
        calculateRatio();
      });
      minInvestmentUnit.addEventListener('change', () => {
        minUnit();
        calculateMinAmount();
      });
      maxInvestmentUnit.addEventListener('change', () => {
        maxUnit();
        calculateMaxAmount();
      });
      subordinatedAmount.addEventListener('change', () => {
        subordinated();
        calculateTotalAmount();
        calculateRatio();
      });
    }

    function calculateAmount() {
      const inputNumberOfUnits = numberOfUnits.value;
      const inputUnitPrice = unitPrice.value;

      const targetAmount = Number(inputNumberOfUnits * inputUnitPrice);
      if (inputNumberOfUnits === null || inputUnitPrice === null) {
        displayAmount.textContent = '0';
      } else {
        displayAmount.textContent = targetAmount.toLocaleString();
      }
    }

    function minUnit() {
      const inputMinUnit = minInvestmentUnit.value;

      if (!inputMinUnit) {
        displayMinUnit.textContent = '0';
      } else {
        displayMinUnit.textContent = inputMinUnit.toLocaleString();
      }
    }

    function calculateMinAmount() {
      const inputMinInvestmentUnit = minInvestmentUnit.value;
      const inputUnitPrice = unitPrice.value;

      const targetMinAmount = Number(inputMinInvestmentUnit * inputUnitPrice);
      if (inputMinInvestmentUnit != null && inputUnitPrice != null) {
        displayMinAmount.textContent = targetMinAmount.toLocaleString();
      } else {
        displayMinAmount.textContent = '0';
      }
    }

    function maxUnit() {
      const inputMaxUnit = maxInvestmentUnit.value;

      if (!inputMaxUnit) {
        displayMaxUnit.textContent = '0';
      } else {
        displayMaxUnit.textContent = inputMaxUnit.toLocaleString();
      }
    }

    function calculateMaxAmount() {
      const inputMaxInvestmentUnit = maxInvestmentUnit.value;
      const inputUnitPrice = unitPrice.value;

      const targetMaxAmount = Number(inputMaxInvestmentUnit * inputUnitPrice);
      if (inputMaxInvestmentUnit != null && inputUnitPrice != null) {
        displayMaxAmount.textContent = targetMaxAmount.toLocaleString();
      } else {
        displayMaxAmount.textContent = '0';
      }
    }

    function subordinated() {
      const inputSubordinatedAmount = Number(subordinatedAmount.value);

      if (!inputSubordinatedAmount) {
        displaySubordinatedAmount.textContent = '0';
      } else {
        displaySubordinatedAmount.textContent = inputSubordinatedAmount.toLocaleString();
      }
    }

    function calculateTotalAmount() {
      const inputNumberOfUnits = Number(numberOfUnits.value);
      const inputUnitPrice = Number(unitPrice.value);
      const inputSubordinatedAmount = Number(subordinatedAmount.value);

      const preferredInvestment = inputNumberOfUnits * inputUnitPrice;
      const targetAmount = preferredInvestment + inputSubordinatedAmount;

      if (!inputNumberOfUnits || !inputUnitPrice) {
        displayTotalAmount.textContent = '0';
      } else {
        displayTotalAmount.textContent = targetAmount.toLocaleString();
      }
    }

    function calculateRatio() {
      const preferred = Number(numberOfUnits.value * unitPrice.value);
      const subordinated = Number(subordinatedAmount.value);
      const total = preferred + subordinated;

      const targetAmount = `${Math.round(((preferred / total) * 100))} : ${Math.round(((subordinated / total) * 100))}`;

      if (preferred === 0) {
        displayRatio.textContent = '-';
      } else {
        displayRatio.textContent = targetAmount.toLocaleString();
      }
    }
  }
}
